const prefix = 'SETTING_RECEIPT_'

export const SETTING_RECEIPT_SET_PROFILE = `${prefix}SET_PROFILE`
export const SETTING_RECEIPT_PAGE_REQUEST = `${prefix}PAGE_REQUEST`
export const SETTING_RECEIPT_CHANGE_OUTLET = `${prefix}CHANGE_OUTLET`
export const SETTING_RECEIPT_CHANGE_OUTLET_NAME = `${prefix}CHANGE_OUTLET_NAME`
export const SETTING_RECEIPT_SUBMIT_FORM = `${prefix}SUBMIT_FORM`

export const SETTING_RECEIPT_CHANGE_PAGE = `${prefix}CHANGE_PAGE`
export const SETTING_RECEIPT_SET_OUTLETS = `${prefix}SET_OUTLETS`



// WEBPACK FOOTER //
// ./app/actions/setting/receipt/constants.js